var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"credit-status"},[_c('b-badge',{attrs:{"variant":_vm.variant}},[_c('font-awesome-icon',{attrs:{"icon":['fa', 'exclamation-circle']}}),_vm._v(" "+_vm._s(_vm.score)+": "+_vm._s(_vm.text)+" ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }